export default __webpack_public_path__ + "static/media/srboiNgirl_w320.021ea8ce.jpeg";